export default "__VITE_ASSET__BYnpPQHi__"